
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.ExcessPostRouteTime = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'ExcessPostRouteTimeEvent'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'excessTimeContainer'
            }
          }
        ]
      }]
    };
  },

  renderFields() {
    //Create Monet fields
    const excessTime = new Monet.UI.Fields.Render({
      name: 'excessTime',
      label: 'event.ExcessPostRouteTime.excessTime',
      defaultValue: '0',
      mandatory: false,
      type: 'INTEGER',
    }).render();

    Greenmile.Checks.EventCheck.ExcessPostRouteTime.fields = { excessTime };

    //Append fields to DOM  
    const excessTimeContainer = document.querySelector('#ExcessPostRouteTimeEvent #excessTimeContainer');
    excessTimeContainer.appendChild(excessTime.rootEl);
  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.ExcessPostRouteTime.renderFields();
    const fields = Greenmile.Checks.EventCheck.ExcessPostRouteTime.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.excessTime.setValue(jsonParam.excessTime);
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.ExcessPostRouteTime.fields;
    return JSON.stringify({
        excessTime: fields.excessTime.getValue()
    });
  }

};